import { defineComponent } from 'vue';
import TSolutionButton from './SolutionButton.vue';
export default defineComponent({
  name: 'TSolutionFooter',
  components: {
    TSolutionButton
  }
});